export default __webpack_public_path__ + "static/gotasCaja-b8bb2a3b9b975e63dd85914d3bf2f6d7.png";